export default "__VITE_ASSET__DFckDMEN__"